// extracted by mini-css-extract-plugin
export default {"rightSectionMainContainer":"RightSection_rightSectionMainContainer__5FuTW","hideContent":"RightSection_hideContent__7enVl"};